import React, { FunctionComponent, ReactNode } from 'react';
import { useNotNullableContext } from '../../hooks/useNotNullableContext';
import { PageMetaContext } from '../../context/PageMetaContext';

const IsQRCode: FunctionComponent = ({
  children,
}: {
  children?: ReactNode;
}) => {
  const { currentUrl } = useNotNullableContext(PageMetaContext);
  const isQRCode = currentUrl?.endsWith('/qrcode');

  return isQRCode ? <>{children}</> : null;
};

export default IsQRCode;
